export default __webpack_public_path__ + "static/media/blue_team_win.641b8d5f.webp";